import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { useNavigate } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { tableNoPaginationOptions } from '../../../component/helpers/table';
import { formatTimestamp, formatTimeInHMS } from '../../helpers/tablesFuncHelpers';
import CustomButton from '../../../component//CustomButton';
import '../../../component/dump/menuComponents/menuComponents.sass';

const StopReportBSTable = (props) => {
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportData' });
	const { data, toggleLoader } = props;
	const [expand, setExpand] = useState(data);
	const navigate = useNavigate();

	useEffect(() => {
		setExpand(data);
	}, [data]);

	const formatLongStops = (cell) => {
		return (cell >= 30 ? <span style={{ backgroundColor: 'yellow' }}>{t('Long_Stops')}</span> : '-')
	};

	const format = (cell) => {
		return (cell >= 30 ? <span style={{ color: 'yellow' }}>{t('Long_Stops')}</span> : '-')
	};

	const formatMapView = (cell, row) => {
		return (
			<div className="map-view-link">
				<CustomButton
					variant="link"
					onClick={() => navigate('/', {
						state: { id: row.device_id, lat: row.lat, lng: row.lng, type: 'reports' },
					})}
				>
					{t('View')}
				</CustomButton>
			</div>
		)
	};

	return (
		<div className="expanded-wrapper">
			<div className="expanded-body">
				<BootstrapTable
					data={expand}
					{...tableNoPaginationOptions}
				>
					<TableHeaderColumn
						dataField="start_ts"
						width="12%"
						dataSort
						dataFormat={formatTimestamp}
					>
						{t('headerStart')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="12%"
						dataField="end_ts"
						dataSort
						dataFormat={formatTimestamp}
					>
						{t('headerEnd')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="10%"
						dataField="duration"
						dataFormat={formatTimeInHMS}
						dataSort
					>
						{t('headerDuration')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="15%"
						dataField="location"
						dataSort
					>
						{t('headerLocation')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="12%"
						dataField="type"
						dataSort
					>
						{t('headerType')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="17%"
						dataField="geofence"
						dataSort
					>
						{t('headerGeofence')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="12%"
						dataField="duration"
						dataSort
						dataFormat={formatLongStops}
						tdStyle={{ whiteSpace: 'normal' }}
					>
						{t('headerException')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="10%"
						isKey
						dataField="device_id"
						dataFormat={formatMapView}
						csvFormat={formatMapView}
					>
						{t('headerMap')}
					</TableHeaderColumn>
				</BootstrapTable>
			</div>
		</div>
	)
}

export default connect(
	null,
	dispatch => ({
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	})
)(StopReportBSTable);
